module.exports = __webpack_public_path__ + "static/image/together/pc/visual.ver2_0_2.jpg?3dd81e34";